import axios from 'axios';
import { setOnScreenEls, checkOnScreenEls } from '../common/on-screen';
import modals from '../common/modals.js';

import '../../sass/blocks/team-list.scss';

( () => {
    const searchTeamMembersAction = 'chadsan_theme_search_team_members';

    const $teamLists = document.querySelectorAll('.team-list');

    if ( !$teamLists ) return;

    $teamLists.forEach( $teamList => {
        const $searchForm = $teamList.querySelector('.team-list__search');
        const $searchInput = $teamList.querySelector('.team-list__search-input');
        const $groupSelect = $teamList.querySelector('.team-list__group-select');
        const $list = $teamList.querySelector('.team-list__list-inner');

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        
        const searchTeamMembers = () => {
            if (!GLOBALS?.AJAX_URL) return;

            const searchTerm = $searchInput.value;
            const teamMemberGroup = $groupSelect.value;

            const { nonce, noResultsMessage } = $list.dataset;

            $list.classList.add('loading');

            axios.get( GLOBALS.AJAX_URL, {
                cancelToken: source.token,
                params: {
                    action: searchTeamMembersAction,
                    nonce: nonce,
                    block_id: $teamList.id,
                    search: searchTerm,
                    team_member_group: teamMemberGroup
                }
            } ).then( response => {
                const url = new URL(window.location.href);
                const searchParams = url.searchParams;

                if ( response.data.html ) {
                    $list.innerHTML = response.data.html;
                } else {
                    $list.innerHTML = `<div class="team-list__list-no-results on-screen"><div class="fade-slide-in">${noResultsMessage}</div></div>`;
                }

                setOnScreenEls();
                checkOnScreenEls();

                $list.dataset.search = response?.data?.search ?? '';
                $list.dataset.teamMemberGroup = response?.data?.team_member_group ?? '';

                searchParams.set('search', response?.data?.search ?? '');
                searchParams.set('team_member_group', response?.data?.team_member_group ?? '');
                searchParams.set('block_id', $teamList.id);

                window.history.replaceState('', '', url.toString());

                if ( response?.data?.team_member_group ) {
                    $teamList.querySelector('.team-list__group-filter-link.active')?.classList.remove('active');
                    $teamList.querySelector(`.team-list__group-filter-link[data-team-member-group=${response.data.team_member_group}]`)?.classList.add('active');
                }
                
                modals();
            } ).catch( error => {
                console.log(error?.response);
            } ).finally( () => {
                $list.classList.remove('loading');
            } );
        };

        const initSearch = () => {
            if (!$searchInput || !$groupSelect || !$searchForm) return;

            let searchTimeout;

            const submitSearchTeamMembersForm = () => {
                clearTimeout(searchTimeout);

                $list.classList.add('loading');

                searchTimeout = setTimeout(() => {
                    searchTeamMembers();
                }, 500);
            }

            $searchInput.addEventListener('keyup', submitSearchTeamMembersForm);

            $groupSelect.addEventListener('change', () => {
                $searchInput.value = '';
                
                searchTeamMembers();
            });

            $searchForm.addEventListener('submit', e => {
                e.preventDefault();
                
                submitSearchTeamMembersForm();
            });
        };

        initSearch();
    } );
} )();
